module.exports = __webpack_public_path__ + "static/media/RefillScreen.88c14fc4.png";